import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideModal, setModalButtonLoading  } from "../../redux/modal/actions";

const getIcon = (type) => {
  switch (type) {
    case "success":
      return <i className="bi bi-check-circle-fill text-success fs-1"></i>;
    case "error":
      return <i className="bi bi-x-circle-fill text-danger fs-1"></i>;
    case "warning":
      return <i className="bi bi-exclamation-triangle-fill text-warning fs-1"></i>;
    default:
      return null;
  }
};

export default function CommonBootstrapModal() {
  const dispatch = useDispatch();
  const modal = useSelector((state) => state.modalReducer);

  const {
    open,
    title,
    message,
    iconType,
    autoClose,
    autoCloseTime = 2000,
    onYes,
    onNo,
    yesLabel = "Ok",
    noLabel = "Cancel",
    yesType,
    loadingBtn,
  } = modal;

  useEffect(() => {
    if (open && autoClose) {
      const timer = setTimeout(() => {
        dispatch(hideModal());
      }, autoCloseTime);
      return () => clearTimeout(timer);
    }
  }, [open, autoClose, autoCloseTime, dispatch]);

  if (!open) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-top">
          <div className="modal-content text-center">

            <div className="modal-body">
              {getIcon(iconType)}

              <h5 className="mt-3">{title}</h5>
              <p className="text-muted">{message}</p>

              {(onYes || onNo) && (
                <div className="mt-3">
                  {onNo && (
                    <button
                      className="btn btn-secondary me-2"
                      onClick={() => {
                        onNo();
                        dispatch(hideModal());
                      }}
                    >
                      {noLabel}
                    </button>
                  )}

              {onYes && (
                <button
                  className="btn btn-primary"
                  disabled={yesType === "api" && loadingBtn === "yes"}
                  onClick={() => {
                    if (yesType === "api") {
                      dispatch(setModalButtonLoading("yes")); //
                      onYes(); // API call
                    } else {
                      onYes(); // normal action
                      dispatch(hideModal()); // close immediately
                    }
                  }}
                >
                  {yesType === "api" && loadingBtn === "yes" ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Processing...
                    </>
                  ) : (
                    yesLabel
                  )}
                </button>
              )}


                </div>
              )}
            </div>

          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
}